import React, { useEffect } from 'react';
import Cal from "@calcom/embed-react";

function Booking() {
  useEffect(() => {
    // Override scroll behavior globally for this page
    const originalScrollTo = window.scrollTo;
    const originalScrollIntoView = Element.prototype.scrollIntoView;

    // Store the current scroll position when component mounts
    // let lastScrollPosition = window.scrollY;

    // Override scrollTo function
    window.scrollTo = function(x, y) {
      // If scroll is to top (0), ignore it
      if (y === 0) {
        return;
      }
      originalScrollTo.call(this, x, y);
    };

    // Override scrollIntoView function
    Element.prototype.scrollIntoView = function(options) {
      // Only allow scrollIntoView if it's not from the calendar iframe
      const isFromCalendar = this.closest('iframe') || 
                           this.querySelector('iframe') || 
                           this.id?.includes('cal') ||
                           this.className?.includes('cal');
      
      if (!isFromCalendar) {
        originalScrollIntoView.call(this, options);
      }
    };

    // Cleanup function
    return () => {
      window.scrollTo = originalScrollTo;
      Element.prototype.scrollIntoView = originalScrollIntoView;
    };
  }, []);

  return (
    <>
      {/* Custom CSS to prevent unwanted scrolling */}
      <style>{`
        html {
          scroll-behavior: auto !important;
        }
        
        /* Target the Cal.com iframe specifically */
        iframe[src*="cal.com"] {
          scroll-behavior: auto !important;
        }
        
        /* Prevent any element from auto-scrolling */
        * {
          scroll-behavior: auto !important;
        }
      `}</style>
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="w-full max-w-4xl mx-auto mb-6">
          <div className="text-base space-y-2">
            <p>Thank you for booking a tattoo session with me!</p>
            <p>Please read the FAQ below. :)</p>
            <p>For more details, visit the Info page. For any other questions, feel free to reach out at contact@moolmit.tattoo</p>
          </div>
        </div>

        {/* Calendar container */}
        <div className="relative">
          <Cal
            calLink="moolmit-tattoo/booking"
            style={{
              width: "100%", 
              height: "800px",
              minHeight: "800px",
            }}
            config={{
              layout: "month_view",
              hideEventTypeDetails: false,
              initialView: "month"
            }}
          />
        </div>
        
        {/* Extra space at bottom for mobile */}
        <div className="h-64 md:h-8" />
      </div>
    </>
  );
}

export default Booking;
